import { useState } from "react";
import { EditingModal } from "./EditingModal";

/**
 * A Component that allows the user to edit the text of a particular section of a ProjectCard
 * To do so, the user will click on the text and a modal will pop up with the text already filled in
 * The user can then edit the text and click save to update the text
 * @param text - The original text
 */

export function ProjectEditComponent({ text, setCurrentText, project_id }: { text: string; setCurrentText: (text: string) => void; project_id: string; }) {
    const [isEditing, setIsEditing] = useState(false);

    const handleClick = () => {
        if (!isEditing) {
            setIsEditing(true);
        }
    };

    return (
        <div onClick={handleClick}>
            {isEditing ?
                <EditingModal text={text} setIsEditing={setIsEditing} project_id={project_id} setCurrentText={setCurrentText} /> :
                <div className="hover:underline cursor-pointer" title="Click to edit">
                    {text ? text :
                        <p className="italic">
                            (No description)
                        </p>}
                </div>}
        </div>
    );
}
